//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show (val) {
      this.$emit('update:show', val)
    }
  }
}



// WEBPACK FOOTER //
// ./~/.2.9.2@vux/src/components/loading/index.vue